import React from "react";
import { FaCheckCircle } from 'react-icons/fa';
import Tooltip from "@material-ui/core/Tooltip/index";

export default function Confirmed({ id, onConfirmStatus }) {
  return (
    <Tooltip title={id ? "Confirmed" : "Not Confirmed"} placement="top">
      <button
        aria-label={id ? "Confirmed" : "Not Confirmed"}
        className={`btn mr-2 btn-sm btn-icon btn-bg-light ${
          id ? "btn-text-success" : "btn-text-danger"
        }`}
        onClick={() => onConfirmStatus(id)}
      >
        <FaCheckCircle  style={{width:"18px", height:"18px"}} />
      </button>
    </Tooltip>
  );
}
